
import wmConfig												from "../data/wmConfig";
import ToolTurbine											from "../classes/ToolTurbine";
import ToolSensor											from "../classes/ToolSensor";
import {ToolPowerline, ToolPowerlineAdd, ToolPowerlineDel}	from "../classes/ToolPowerline";
import {ToolRoad, ToolRoadAdd, ToolRoadDel}					from "../classes/ToolRoad";
import ToolAnnotation										from "../classes/ToolAnnotation";
import {ToolMeasure}										from "../classes/ToolMeasure";
import {ToolBoundary}										from "../classes/ToolBoundary";
import vindrApi												from "../utils/vindrapi";
import drawTheme											from "../utils/drawUtilsTheme";

class turbineControl {
	
	handler = null;
	
	constructor(map, draw, scenario, setScenario, log){
		this.map			= map;
		this.draw			= draw;
		this.draw.tc		= this;
		this.scenario		= scenario;
		this.setState		= setScenario;
		this.record			= log;
		this.es				= this._escape.bind(this);
		this.clickedButton	= null;
	}
	setScenario(scenario){
		this.scenario = scenario;
		this.setState(scenario);
		if(scenario.scenario_id && !this.draw.context.versionid)
			this.map.controlBar.enable(['turbine_modeon', 'turbine_add', 'add_circle', 'turbine_remove', 'add_boundary', 'powerline_modeon','add_powerline', 'road_modeon', 'add_road', 'sensor_modeon', 'annotation_modeon', 'boundary_modeon']);
		else {
			this.map.controlBar.disable();
		}
		this.map.controlBar.enable(['add_circle', 'landowner_mode', 'measure_modeon']);
		

		if(this.handler && this.handler.update)
			this.handler.update();
		if(this.handler && this.handler.display)
			this.handler.display();
		
	}
	init(){
		
		//clear other button event handlers
		this.clickedButton.classList.add('active');
		this.exitOthers();
		if(this.draw?.context?.getters?.workMode?.label != 'Project' && this.changeWorkMode)
			this.changeWorkMode('default', this.draw.context.getters.project);

		if(turbineControl.resetFn){
			clearTimeout(turbineControl.resetFn);
			turbineControl.resetFn = null;
		}		
		if(this.handler && this.handler.init)
			this.handler.init();
		
		document.addEventListener('keyup', this.es);
		this.map.disableEvents = 1;
		var self = this;
	}
	secondaryInit(){
		
		//clear other button event handlers
		this.secondaryButton.classList.add('active');
		this.exitOthers();
	
		if(this.secondaryHandler && this.secondaryHandler.init)
			this.secondaryHandler.init();
		
		document.addEventListener('keyup', this.es);
		this.map.disableEvents = 1;
	}
	_escape(e){
		if(e.keyCode === 27 /*escape*/) {
			if(this.secondaryHandler){
				
				this.exitSecondary();
				return;
			}
			this.exit();
		}
	}
	
	exit(){
		this.map.getContainer().classList.remove("cursor-add-turbine", "cursor-delete-turbine", "cursor-pen");
		this.clearEventHandlers();
		this.map.disableEvents = 0;
		this.draw.draw.changeMode('simple_select');
		
		if(this.handler && this.handler.exit){
			this.handler.exit();
			this.handler = null;
		}
		if(this.clickedButton && this.clickedButton.id){
			document.querySelectorAll("#"+this.clickedButton.id).forEach((e)=>{
				e.classList.remove('active');
			});
			this.clickedButton = null;
		}
		document?.activeElement.blur();
		if(!turbineControl.resetFn){
			turbineControl.resetFn = setTimeout(()=>{
				this.landownerModeForce();
			}, 50);
		}
	}
	
	exitSecondary(){
		this.map.getContainer().classList.remove("cursor-measure", "cursor-delete-turbine", "cursor-pen");
		this.clearEventHandlers();
		
		this.draw.draw.changeMode('simple_select');
		
		if(this.secondaryHandler && this.secondaryHandler.exit){
			this.secondaryHandler.exit();
			this.secondaryHandler = null;
		}
		if(this.secondaryButton){
			
			document.querySelectorAll("#"+this.secondaryButton.id).forEach((e)=>{
				e.classList.remove('active');
			});
			this.secondaryButton = null;
		}
		document?.activeElement.blur();
	}
	clearEventHandlers(){
		this.map.off('click', this.ad);
		this.map.off('click', this.rm);
		document.removeEventListener('keyup', this.es);
	}
	
	addBoundary(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target;
		this.init();
		this.map.getContainer().classList.add("cursor-pen");
		this.clickedButton.classList.add('active');
		this.draw.draw.changeMode('boundary_mode', {onFinish:()=>{this.exit();}});
		//change to boundary mode
		
	}
	addPowerline(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolPowerlineAdd(this);
		this.init();
		//change to boundary mode
		
	}
	delPowerline(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolPowerlineDel(this);
		this.init();
		//change to boundary mode
		
	}
	powerlineMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolPowerline(this);
		this.init();
	}
	powerlineModeForce(){
		if(this.clickedButton && this.clickedButton.id == 'powerline_modeon'){
			return;
		}
		document.querySelector("#powerline_modeon").click();
	}
	annotationMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolAnnotation(this);
		this.init();
	}
	roadMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolRoad(this);
		this.init();
	}
	
	boundaryMode(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolBoundary(this);
		this.init();
	}
	roadModeForce(){
		if(this.clickedButton && this.clickedButton.id == 'road_modeon'){
			return;
		}
		document.querySelector("#road_modeon").click();
	}
	
	addRoad(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolRoad(this, true);
		this.init();
		//change to boundary mode
		
	}
	addProject(e){
		
		this.exit();
		this.clickedButton = e.target.closest("button");;
		this.init();
		this.map.getContainer().classList.add("cursor-pen");
		this.clickedButton.classList.add('active');
		this.draw.draw.changeMode('boundary_mode', {onFinish:()=>{this.exit();}});
		this.stackDrawLayers();
		//change to boundary mode
		
	}
	turbineMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolTurbine(this);
		this.init();
	}
	measureMode(e){
		e.stopPropagation();
		if(this.toggleSecondary(e))
			return;
		this.exitSecondary();
		this.secondaryButton = e.target.closest("button");
		this.secondaryButton.classList.add('active');
		this.secondaryHandler = new ToolMeasure(this);
		this.secondaryInit();
	}
	landownerMode(e){
		e.stopPropagation();
		this.exit();
		if(this.workMode?.obj)
			this.workMode.obj.refresh();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = null;
	}
	landownerModeForce(){
		document.querySelector("#landowner_mode")?.click();
	}
	updateTurbine(turbineid, coordinates){
		
		if(!this.scenario || !this.scenario.scenario_id)
			return;
		var i = this.scenario.wtgs.findIndex((elem)=>elem.turbineid == turbineid);
		if(i>-1){
			if(coordinates){
				this.scenario.wtgs[i].geometry.coordinates = coordinates;
				
			}
			else{
				delete this.scenario.wtgs[i].geometry;
			
				//check if turbine was new, if so don't send object
				if(typeof this.scenario.wtgs[i].turbineid != 'number')
					this.scenario.wtgs.splice(i, 1);
			}
			this.scenario.modified = 1;
			
			this.setScenario(this.scenario);
			this.record().add(this.scenario);
		}
	}
	updateTurbineName(name, turbineid, refresh){
		
		if(!this.scenario || !this.scenario.scenario_id)
			return;
		var i = this.scenario.wtgs.findIndex((elem)=>elem.turbineid == turbineid);
		if(i>-1){
			this.scenario.wtgs[i].name = name ? name : 'Turbine '+turbineid;
			
			//don't update in API if turbine is temporary
			if(!isNaN(turbineid))
				vindrApi.updateTurbineName({name:name}, this.scenario.projectid, this.scenario.scenario_id, turbineid);
			
			this.scenario.modified = 1;
			this.record().add(this.scenario);
			//this.setScenario(this.scenario);
		}
		
		if(refresh)
			this.draw.drawTurbines(this.scenario, this.updateTurbine.bind(this), this.tc);
	}

	sensorMode(e){
		e.stopPropagation();
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.clickedButton.classList.add('active');
		this.handler = new ToolSensor(this);
		this.init();
	}
	sensorModeForce(){
		document.querySelector("#sensor_modeon").click();
	}
	addSensor(e){
		if(!this.scenario.scenario_id || this.toggle(e)) //editing main scenario not allowed
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.handler = new ToolSensor(this, 1);
		this.init();
		this.map.getContainer().classList.add("cursor-add-sensor");
	}
	removeSensor(e){
		if(!this.scenario.scenario_id || this.toggle(e))
			return;
		this.exit();
		this.clickedButton = e.target.closest("button");
		this.handler = new ToolSensor(this, 2);
		this.init();
		this.map.getContainer().classList.add("cursor-delete-sensor");
	}
	toggle(e){
		if(this.clickedButton && this.clickedButton.id == e.target.closest('button').id){ //if clicking the same button again exit function
			this.exit();
			return true;
		}
		return false;
	}
	toggleSecondary(e){
		if(this.secondaryButton && this.secondaryButton.id == e.target.closest('button').id){ //if clicking the same button again exit function
			this.exitSecondary();
			return true;
		}
		return false;
	}
	exitOthers(){
		const event = new KeyboardEvent("keyup",{
			'keyCode': 27
		});
		this.map.getContainer().dispatchEvent(event);
	}
	stackDrawLayers(){
		
		drawTheme.forEach((l)=>{
			if(this.map.getLayer(l.id+".cold"))
				this.map.moveLayer(l.id+".cold");
			if(this.map.getLayer(l.id+".hot"))
				this.map.moveLayer(l.id+".hot");
		});
		
	}
}
export default turbineControl;